document.addEventListener("DOMContentLoaded", () => {

  /* ==========================================================
     REVEAL
  ========================================================== */

  const revealTargets = document.querySelectorAll(
    ".vhi-hero__content, .vhi-hero__media, .vhi-story__content, .vhi-story__image, .vhi-break__content, .vhi-comparison__header, .vhi-column, .vhi-about__content, .vhi-about__image, .vhi-cta"
  );

  revealTargets.forEach(el => {
    el.classList.add("vhi-reveal");
  });

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);

      }

    });

  }, {
    threshold: 0.15
  });

  revealTargets.forEach(el => observer.observe(el));

  /* ==========================================================
     PARALLAX HERO
  ========================================================== */

  const heroImage = document.querySelector(".vhi-hero__image");

  if (heroImage) {

    window.addEventListener("scroll", () => {

      const y = window.scrollY * 0.12;

      heroImage.style.transform = `translateY(${y}px)`;

    }, { passive: true });

  }

  /* ==========================================================
     SCROLL SUAVE
  ========================================================== */

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {

    anchor.addEventListener("click", function(e){

      const target = document.querySelector(this.getAttribute("href"));

      if(!target) return;

      e.preventDefault();

      target.scrollIntoView({

        behavior:"smooth",
        block:"start"

      });

    });

  });

});